import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinhadapsar() {

const cardData = {
keyword: "Urbania on Rent in Hadapsar",
headingDescription: "Urbania on Rent in Hadapsar is a practical group transportation option for corporate travel, family trips, weddings, airport transfers, employee movement, outstation journeys, and special events. Ruturaj Enterprises provides spacious Urbania vehicles with comfortable seating, air conditioning options, professional driver assistance, and flexible arrangements for different group sizes. Whether the requirement starts from Hadapsar, Magarpatta City, Amanora, or nearby Pune areas, an Urbania can help families, companies, and groups travel together in a comfortable and organized manner.",
topPlaces: [
{
title: "Magarpatta City",
description: "Magarpatta City is one of the major corporate and residential destinations near Hadapsar. Urbania transportation can be arranged for employee movement, corporate events, business meetings, team outings, airport transfers, and group travel connecting Magarpatta with other Pune areas and outstation destinations."
},
{
title: "Amanora Park Town",
description: "Amanora Park Town is a prominent residential and commercial development in the Hadapsar region. A spacious Urbania can be useful for family trips, weddings, corporate events, airport transfers, sightseeing, and group journeys starting from Amanora and nearby areas."
},
{
title: "SP Infocity Hadapsar",
description: "SP Infocity is an important IT and business destination in Hadapsar where companies may require organized employee and group transportation. Urbania hire can support corporate meetings, office events, team outings, airport transfers, and business travel."
},
{
title: "Hadapsar Industrial Estate",
description: "Hadapsar Industrial Estate serves a wide range of businesses and industrial establishments. Urbania transportation can be arranged for staff movement, company events, business visits, employee outings, and group transfers between Hadapsar and other Pune locations."
},
{
title: "Kharadi",
description: "Kharadi is a major business corridor located close to Hadapsar and is home to several corporate offices and IT destinations. Urbania services can connect Hadapsar groups with Kharadi for corporate events, employee travel, airport transfers, family functions, and outstation journeys."
},
{
title: "Viman Nagar",
description: "Viman Nagar is an important airport-connected locality near Hadapsar. Groups can use Urbania transportation for airport pickup and drop, corporate travel, family trips, wedding functions, hotel transfers, and journeys between Hadapsar and other Pune destinations."
},
{
title: "Pune International Airport",
description: "Pune International Airport is a common destination for business travellers, families, and groups from Hadapsar. A larger Urbania can accommodate several passengers and their luggage for coordinated airport transfers between Hadapsar, the airport, hotels, offices, and event venues."
},
{
title: "Mundhwa",
description: "Mundhwa provides convenient connectivity between Hadapsar, Kharadi, Koregaon Park, and eastern Pune. Urbania hire can be useful for families, corporate teams, wedding groups, tourists, and event participants travelling together from the Hadapsar region."
},
{
title: "Kondhwa",
description: "Kondhwa is connected to Hadapsar through major southern Pune routes and is an important residential area. Urbania transportation can support family holidays, weddings, pilgrimage trips, corporate events, airport transfers, and group travel from Hadapsar toward southern Pune."
},
{
title: "Koregaon Park",
description: "Koregaon Park is a popular commercial, hospitality, and lifestyle destination within reach of Hadapsar. Urbania services can be useful for corporate visitors, family groups, wedding guests, tourists, and event participants travelling between Hadapsar and hotels or venues in the area."
}
],
services: [
{
name: "13 Seater Urbania on Rent in Hadapsar",
description: "13 Seater Urbania on Rent in Hadapsar is suitable for medium-sized families, corporate teams, event groups, and tourists requiring comfortable shared transportation. It can be arranged for local travel, airport transfers, weddings, corporate programs, sightseeing, and outstation journeys."
},
{
name: "17 Seater Urbania on Rent in Hadapsar",
description: "17 Seater Urbania on Rent in Hadapsar is useful for larger groups that prefer travelling together in one spacious vehicle. It can support corporate events, family holidays, wedding functions, school trips, pilgrimage tours, airport transfers, and longer outstation journeys."
},
{
name: "Urbania Hire in Hadapsar Pune",
description: "Urbania Hire in Hadapsar Pune provides a convenient group transportation option for residents, companies, families, tourists, and event organizers. Professional driver support and spacious seating make it suitable for both local Pune travel and intercity journeys."
},
{
name: "Urbania Booking in Hadapsar",
description: "Urbania Booking in Hadapsar allows customers to plan group transportation according to their preferred travel date, pickup location, destination, and itinerary. Advance booking can be useful for weddings, corporate events, family holidays, airport transfers, and outstation tours."
},
{
name: "Luxury Urbania on Rent in Hadapsar",
description: "Luxury Urbania on Rent in Hadapsar offers a premium group transportation option for special occasions, corporate programs, executive travel, family celebrations, and longer journeys. The spacious vehicle provides a comfortable environment for passengers travelling together."
},
{
name: "AC Urbania on Rent in Hadapsar",
description: "AC Urbania on Rent in Hadapsar is suitable for passengers looking for an air-conditioned group vehicle for comfortable travel. It can be used for corporate events, family trips, weddings, airport transfers, sightseeing, and outstation journeys."
},
{
name: "Non AC Urbania on Rent in Hadapsar",
description: "Non AC Urbania on Rent in Hadapsar provides an alternative group transportation option for customers who do not require air conditioning. It can be useful for selected local events, family functions, group travel, school programs, and suitable outstation requirements."
},
{
name: "Urbania Rental Service in Hadapsar",
description: "Urbania Rental Service in Hadapsar provides flexible transportation for families, companies, tourists, and event groups. The vehicle can be arranged for local journeys, corporate programs, weddings, airport transfers, sightseeing, and longer group travel."
},
{
name: "Urbania for Outstation in Hadapsar",
description: "Urbania for Outstation in Hadapsar is suitable for groups travelling from Hadapsar to tourist destinations, pilgrimage locations, nearby cities, and other intercity routes. The spacious vehicle allows passengers to travel together with professional driver assistance."
},
{
name: "Urbania for Corporate Events in Hadapsar",
description: "Urbania for Corporate Events in Hadapsar can be arranged for conferences, seminars, team outings, annual functions, exhibitions, meetings, and company celebrations. It provides a convenient way to move employees, clients, and guests between offices, hotels, and event venues."
},
{
name: "Urbania for Airport Pickup Hadapsar",
description: "Urbania for Airport Pickup Hadapsar provides group transportation to collect multiple passengers from Pune International Airport. The vehicle can accommodate passengers and luggage while keeping families, corporate teams, and event groups together during the transfer."
},
{
name: "Urbania on Rent Near Magarpatta City",
description: "Urbania on Rent Near Magarpatta City is convenient for employees, families, and groups starting their journey around the major business and residential hub. It can be used for corporate events, employee travel, airport transfers, family trips, weddings, and outstation journeys."
},
{
name: "Urbania on Rent Near Amanora Hadapsar",
description: "Urbania on Rent Near Amanora Hadapsar provides group transportation for residents, corporate teams, families, tourists, and event participants around Amanora Park Town. It is suitable for weddings, airport transfers, sightseeing, corporate travel, and outstation trips."
},
{
name: "Urbania for Wedding Function in Hadapsar",
description: "Urbania for Wedding Function in Hadapsar can transport relatives, guests, family members, and event participants between homes, hotels, wedding venues, and reception locations. A dedicated vehicle helps simplify guest movement throughout the wedding schedule."
},
{
name: "Best Urbania Rental in Hadapsar",
description: "Best Urbania Rental in Hadapsar is a search term for customers looking for a suitable larger vehicle with spacious seating, professional driver assistance, and flexible travel arrangements. It can support corporate, family, wedding, airport, and outstation transportation."
},
{
name: "Urbania Tempo Traveller in Hadapsar",
description: "Urbania Tempo Traveller in Hadapsar is suitable for families, corporate groups, tourists, and event participants requiring spacious transportation. It can be arranged for sightseeing, airport transfers, weddings, business travel, pilgrimage tours, and longer journeys."
},
{
name: "Urbania for Family Trip in Hadapsar",
description: "Urbania for Family Trip in Hadapsar provides a convenient group vehicle for families travelling together for holidays, weddings, religious visits, sightseeing, and family functions. Travelling in one vehicle helps keep the group together and simplifies trip coordination."
},
{
name: "Urbania for Group Travel Hadapsar",
description: "Urbania for Group Travel Hadapsar is suitable for friends, families, corporate teams, tourists, and event groups. It can be used for local Pune travel as well as longer outstation journeys where passengers prefer a common vehicle and planned itinerary."
},
{
name: "Affordable Urbania on Rent in Hadapsar",
description: "Affordable Urbania on Rent in Hadapsar is suitable for customers seeking practical group transportation while managing their travel budget. It can be arranged for family trips, corporate events, weddings, airport transfers, sightseeing, and outstation travel."
},
{
name: "Urbania bus on Rent Hadapsar",
description: "Urbania bus on Rent Hadapsar provides a spacious transportation option for groups travelling from Hadapsar. It can support corporate programs, family functions, weddings, school outings, pilgrimage tours, airport transfers, and outstation journeys."
},
{
name: "Urbania busTraveller Hadapsar",
description: "Urbania busTraveller Hadapsar is suitable for larger groups requiring comfortable shared transportation from Hadapsar. It can be used for family holidays, corporate travel, event transportation, sightseeing, wedding functions, and intercity journeys."
},
{
name: "Urbania bus on Rent Magarpatta",
description: "Urbania bus on Rent Magarpatta provides group transportation around Magarpatta City and nearby Hadapsar areas. It is useful for employee travel, corporate events, team outings, family functions, airport transfers, and outstation group trips."
},
{
name: "Urbania bus on Rent Amanora",
description: "Urbania bus on Rent Amanora is suitable for groups travelling from Amanora Park Town and surrounding Hadapsar areas. It can be arranged for weddings, family trips, corporate events, sightseeing, airport transportation, and longer outstation journeys."
}
],
tableData: [
["13 Seater Urbania on Rent in Hadapsar"],
["17 Seater Urbania on Rent in Hadapsar"],
["Urbania Hire in Hadapsar Pune"],
["Urbania Booking in Hadapsar"],
["Luxury Urbania on Rent in Hadapsar"],
["AC Urbania on Rent in Hadapsar"],
["Non AC Urbania on Rent in Hadapsar"],
["Urbania Rental Service in Hadapsar"],
["Urbania for Outstation in Hadapsar"],
["Urbania for Corporate Events in Hadapsar"],
["Urbania for Airport Pickup Hadapsar"],
["Urbania on Rent Near Magarpatta City"],
["Urbania on Rent Near Amanora Hadapsar"],
["Urbania for Wedding Function in Hadapsar"],
["Best Urbania Rental in Hadapsar"],
["Urbania Tempo Traveller in Hadapsar"],
["Urbania for Family Trip in Hadapsar"],
["Urbania for Group Travel Hadapsar"],
["Affordable Urbania on Rent in Hadapsar"],
["Urbania bus on Rent Hadapsar"],
["Urbania busTraveller Hadapsar"],
["Urbania bus on Rent Magarpatta"],
["Urbania bus on Rent Amanora"]
],
whychoose: [
{
WhyChooseheading: "Spacious Transportation for Hadapsar Groups",
WhyChoosedescription: "Urbania vehicles provide a convenient solution for families, employees, corporate teams, tourists, and event groups travelling together from Hadapsar. The larger passenger capacity helps reduce the need to coordinate several smaller vehicles."
},
{
WhyChooseheading: "Convenient for Magarpatta and Amanora",
WhyChoosedescription: "Hadapsar is closely connected with major destinations such as Magarpatta City and Amanora Park Town. Urbania transportation can be arranged around these locations for employee movement, corporate events, family travel, weddings, airport transfers, and group journeys."
},
{
WhyChooseheading: "Suitable for Corporate Travel",
WhyChoosedescription: "Companies can use Urbania vehicles for employee transportation, conferences, seminars, meetings, team outings, annual functions, and business events. A dedicated vehicle makes it easier to coordinate employees and guests between offices, hotels, airports, and venues."
},
{
WhyChooseheading: "Comfortable for Family and Wedding Trips",
WhyChoosedescription: "Families can use a spacious Urbania for holidays, weddings, religious visits, sightseeing, and special functions. Keeping passengers together in one vehicle can simplify pickup arrangements and help the group follow a common travel schedule."
},
{
WhyChooseheading: "Useful for Airport Transfers",
WhyChoosedescription: "Hadapsar has convenient access toward Pune International Airport through the eastern Pune corridor. Urbania vehicles can accommodate groups and luggage for planned airport pickup and drop services involving families, corporate visitors, and event participants."
},
{
WhyChooseheading: "Local and Outstation Travel Options",
WhyChoosedescription: "Urbania rental can be used for short local journeys around Hadapsar and longer outstation trips to tourist, religious, business, and family destinations. This makes the vehicle suitable for different group travel requirements throughout the year."
},
{
WhyChooseheading: "Professional Driver Assistance",
WhyChoosedescription: "A dedicated professional driver can make group transportation more convenient, especially when travelling with several passengers or following a multi-stop itinerary. Customers can focus on their event, family plans, or business activities during the journey."
},
{
WhyChooseheading: "Pickup Coverage Around Eastern Pune",
WhyChoosedescription: "Ruturaj Enterprises can arrange Urbania transportation around Hadapsar and nearby areas such as Magarpatta City, Amanora, SP Infocity, Kharadi, Viman Nagar, Pune Airport, Mundhwa, Kondhwa, and Koregaon Park according to the customer's travel requirement."
}
]
};
















const faqData = [
{
question: "How can I hire an Urbania on rent in Hadapsar?",
answer: "Customers can enquire about an Urbania rental in Hadapsar by providing the pickup address, travel date, destination, passenger count, rental duration, and planned route. Ruturaj Enterprises can discuss group transportation requirements for family tours, corporate programs, weddings, sightseeing trips, airport transfers, and outstation journeys."
},
{
question: "Who can rent an Urbania in Hadapsar?",
answer: "Families, corporate groups, wedding parties, schools, colleges, tour groups, social organizations, and other passenger groups can enquire about Urbania rental in Hadapsar. The vehicle can be considered when several people need to travel together for a local event, tour, or longer journey."
},
{
question: "Can I hire an Urbania from Hadapsar for an outstation journey?",
answer: "An Urbania can be arranged for group travel from Hadapsar to destinations such as Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, Kolhapur, Goa, Aurangabad, and other locations. Customers can discuss one-way, round-trip, or multi-day requirements according to their planned itinerary."
},
{
question: "Is Urbania suitable for family trips from Hadapsar?",
answer: "Families planning holidays, reunions, religious tours, and sightseeing programs can enquire about an Urbania from Hadapsar. Keeping the group together in one vehicle can simplify coordination for departure times, hotel transfers, sightseeing stops, and return travel."
},
{
question: "Can I book an Urbania in Hadapsar for wedding transportation?",
answer: "Wedding organizers and families can use an Urbania to transport relatives and guests between homes, hotels, marriage halls, reception venues, railway stations, and airports. The group vehicle can be planned around the wedding schedule when several guests need to move together."
},
{
question: "Can companies hire an Urbania on rent in Hadapsar for corporate travel?",
answer: "Businesses in and around Hadapsar can enquire about Urbania rental for employee outings, conferences, training programs, team activities, business events, and client transportation. Pickup locations, office addresses, reporting times, passenger count, and destinations can be shared to plan the corporate journey."
},
{
question: "Can Urbania be rented from Hadapsar for Pune Airport transfers?",
answer: "An Urbania can be considered for group transfers between Hadapsar and Pune Airport when several passengers are travelling together. Flight timings, passenger count, luggage requirements, pickup address, and required airport reporting time can be shared while arranging the transportation."
},
{
question: "Can I hire an Urbania from Hadapsar for sightseeing tours?",
answer: "Tour groups and families can enquire about an Urbania for sightseeing programs starting from Hadapsar. The planned route can include multiple attractions, meal stops, hotel pickups, and return travel, helping the complete group remain together during the tour."
},
{
question: "Can schools and colleges rent an Urbania in Hadapsar?",
answer: "Educational groups can use an Urbania for excursions, picnics, educational visits, industrial tours, and recreational programs. The institution or group can provide the passenger count, pickup location, destination, travel date, schedule, and duration while discussing the transportation arrangement with Ruturaj Enterprises."
},
{
question: "What information is required to book an Urbania on rent in Hadapsar?",
answer: "Customers can provide the Hadapsar pickup location, destination, travel date, passenger count, rental period, route details, and expected return timing. Requirements involving multiple stops, hotel transfers, airport travel, wedding functions, corporate events, or sightseeing can also be shared when planning the Urbania rental."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Deepak Shinde",
feedback:
"We hired an Urbania from Hadapsar for a family trip to Shirdi with relatives travelling from different parts of Pune. Ruturaj Enterprises arranged the vehicle according to our pickup schedule, and having everyone travel together made the religious trip much easier to organize from the beginning.",
rating: 5
},
{
id: 2,
name: "Miss. Meenal Joshi",
feedback:
"Our office team planned a one-day outing from Hadapsar and needed enough space for everyone to travel together. We contacted Ruturaj Enterprises for an Urbania and shared our complete itinerary. The group transportation worked well for our schedule and made it easier to keep everyone together during the outing.",
rating: 5
}
];



































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania on Rent in Hadapsar",
  "image": "https://ruturajenterprises.com/assets/images/urbania-on-rent-in-hadapsar.webp",
  "description": "Urbania on Rent in Hadapsar from Ruturaj Enterprises is a convenient group transportation solution for families, corporate teams, wedding groups, airport travellers and passengers planning local or outstation journeys from Hadapsar and surrounding areas. 13 Seater Urbania on Rent in Hadapsar and 17 Seater Urbania on Rent in Hadapsar are suitable for different group sizes, with spacious seating and useful luggage capacity for longer trips. Urbania Hire in Hadapsar Pune and Urbania Booking in Hadapsar can be arranged for sightseeing, corporate travel, family tours, events and planned group transportation. Luxury Urbania on Rent in Hadapsar and AC Urbania on Rent in Hadapsar are suitable for passengers seeking comfortable travel, while Non AC Urbania on Rent in Hadapsar provides an additional group travel option. Urbania Rental Service in Hadapsar can be used for outstation journeys, corporate events, airport transfers, weddings and family functions. Urbania for Outstation in Hadapsar is suitable for long-distance routes, while Urbania for Corporate Events in Hadapsar can support employee gatherings, business programs and group meetings. Urbania for Airport Pickup Hadapsar provides convenient transportation to and from Pune Airport. Customers travelling near Magarpatta City and Amanora can also choose Urbania on Rent Near Magarpatta City and Urbania on Rent Near Amanora Hadapsar for convenient pickup arrangements. Urbania for Wedding Function in Hadapsar, Urbania for Family Trip in Hadapsar and Urbania for Group Travel Hadapsar are suitable for celebrations, vacations, pilgrimages and group tours. Affordable Urbania on Rent in Hadapsar, Urbania Tempo Traveller in Hadapsar, Urbania bus on Rent Hadapsar, Urbania bus Traveller Hadapsar, Urbania bus on Rent Magarpatta and Urbania bus on Rent Amanora provide additional transportation options for larger groups and different travel requirements.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/urbania-on-rent-in-hadapsar"
  }
};







    return (
        <div>

<Helmet>
  <title>
    Urbania on Rent in Hadapsar | 13 & 17 Seater Traveller for Family, Events & Outstation Travel | +91 9763381382
  </title>

  <meta
    name="description"
    content="Urbania on Rent in Hadapsar by Ruturaj Enterprises for 13 and 17 seater group travel, corporate events, airport pickup, weddings, family trips, Magarpatta and Amanora travel, and outstation journeys."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Hadapsar, 13 Seater Urbania on Rent in Hadapsar, 17 Seater Urbania on Rent in Hadapsar, Urbania Hire in Hadapsar Pune, Urbania Booking in Hadapsar, Luxury Urbania on Rent in Hadapsar, AC Urbania on Rent in Hadapsar, Non AC Urbania on Rent in Hadapsar, Urbania Rental Service in Hadapsar, Urbania for Outstation in Hadapsar, Urbania for Corporate Events in Hadapsar, Urbania for Airport Pickup Hadapsar, Urbania on Rent Near Magarpatta City, Urbania on Rent Near Amanora Hadapsar, Urbania for Wedding Function in Hadapsar, Best Urbania Rental in Hadapsar, Urbania Tempo Traveller in Hadapsar, Urbania for Family Trip in Hadapsar, Urbania for Group Travel Hadapsar, Affordable Urbania on Rent in Hadapsar, Urbania bus on Rent Hadapsar, Urbania bus Traveller Hadapsar, Urbania bus on Rent Magarpatta, Urbania bus on Rent Amanora, Urbania Traveller Hadapsar, Urbania with Driver Hadapsar, 13 Seater Urbania Hadapsar, 17 Seater Urbania Hadapsar, Urbania Corporate Cab Hadapsar, Urbania Corporate Travel Hadapsar, Urbania Airport Transfer Hadapsar, Urbania Wedding Rental Hadapsar, Urbania Family Tour Hadapsar, Urbania Outstation Rental Hadapsar, Urbania Group Travel Hadapsar, Urbania Bus Rental Hadapsar, Urbania Traveller Rental Hadapsar, Urbania Rental Near Magarpatta, Urbania Rental Near Amanora"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/107.png' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinhadapsar;